import type { User } from '@frontend/components/agromarket/core/access-control'
import { FundingProduct } from '@frontend/components/agromarket/core/access-control'
import { getCommentFieldForConsulting } from '@/logic/financing/helpers'
import type { IApplyingFinancingOfferRequestBody } from '@/logic/financing/interfaces'
import { EPriceUom } from '@/types'
import { normalizePhoneNumber } from '@/utils/formatUtils'
import type { IConsultingFormValues } from './types'

type TCreateConsultingRequestBodyOptions = {
  values: IConsultingFormValues
  user?: User
  productId?: FundingProduct
  customComment?: string
}

type TCreateConsultingRequestBodyResult = Pick<
  IApplyingFinancingOfferRequestBody,
  'productId' | 'phone' | 'organizationName' | 'organizationInn' | 'comment' | 'agreement'
> &
  Partial<Pick<IApplyingFinancingOfferRequestBody, 'loanAmount'>>

export const createConsultingRequestBody = ({
  values,
  user,
  productId,
}: TCreateConsultingRequestBodyOptions): TCreateConsultingRequestBodyResult => {
  const commonFields = {
    productId: FundingProduct.MARKETPLACE,
    phone: normalizePhoneNumber(values.phone),
    email: user?.email,
    agreement: values.agreement,
    comment: values.purpose || getCommentFieldForConsulting(productId),
  }

  return {
    ...commonFields,
    organizationName: user?.organizationName,
    organizationInn: user?.organizationInn,
    loanAmount: { value: Number(values.loanAmount), uom: EPriceUom.RUB },
  }
}
